export default __webpack_public_path__ + "static/media/heartbeat.bfd99f6c.jpeg";